import axios from "axios"
import { HEADERS } from "../../../../../API/UrlAndPaths"
import store from "../../../../../Redux/store";
import { get_pos_settings_api_res_list, get_pos_time_report } from "./PosSettingsSlice";

export const postPosSettingsAPICall=(body,setState,state)=>{
    axios.post("settings/posConfigurationSettings",body,HEADERS)
    .then((res)=>{
        if(res.status===200){
            setState({...state,message:"pos Configuration Updated",success:true})
        }
    })
    .catch((err)=>{
        setState({...state,message:"Something went wrong !!",error:true})
    })
}

export const viewPosSettingsAPICall=()=>{
    axios.post("settings/viewPosConfigurationSettings",{},HEADERS)
    .then((res)=>{
        if(res.status===200){
           console.log('📦 POS Settings API Response:', {
               hasData: !!res.data,
               posDevices_direct: res.data?.posDevices,
               posDevices_nested: res.data?.data?.posDevices,
               posDevicesCount_direct: res.data?.posDevices?.length || 0,
               posDevicesCount_nested: res.data?.data?.posDevices?.length || 0,
               responseKeys: Object.keys(res.data || {}),
               fullResponse: res.data
           });
           store.dispatch(get_pos_settings_api_res_list({posSettingsResData:res.data}))
        }
    })
    .catch((err)=>{
        console.log(err.response);
    })
}

export const listTimeReportAPICall = async ({branchId, fromDate, endDate, orderType, selectedProductId, reportType, timeRange, shiftId, selectShift, useShiftDates}) => {
    try {
        console.log("[TIME REPORT] API Request:", {
            branchId, 
            fromDate, 
            endDate, 
            orderType, 
            selectedProductId, 
            reportType, 
            timeRange, 
            shiftId, 
            selectShift,
            useShiftDates
        });
        
        const response = await axios.post("pos/listTimeReport", {
            branchId, 
            fromDate, 
            endDate, 
            orderType, 
            selectedProductId, 
            reportType, 
            timeRange, 
            shiftId, 
            selectShift,
            useShiftDates
        }, HEADERS);
        
        if (response.status === 200) {
            console.log("[TIME REPORT] API Response:", {
                totalSales: response.data?.data?.totalSales,
                totalBills: response.data?.data?.totalBills,
                orderIdsCount: response.data?.data?.orderIds?.length,
                timeGraphSlots: response.data?.data?.timeGraph?.length,
                slotSummaryCount: response.data?.data?.slotSummary?.length,
                topProductsCount: response.data?.data?.topProducts?.length,
                _debug: response.data?.data?._debug
            });
            store.dispatch(get_pos_time_report({ posTimeReportResData: response.data }));
            return response.data;
        }
    } catch (err) {
        console.error("[TIME REPORT] API Error:", err.response || err);
        throw err;
    }
}